import { graphql } from "../generated/gql";

export const LinkTagsToCall = graphql(`
  mutation LinkTagsToCall($input: LinkTagsToCallInput!) {
    linkTagsToCall(input: $input) {
      id
    }
  }
`);
